import { bootstrapApplication } from "@angular/platform-browser";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { APP_INITIALIZER, inject } from "@angular/core";
import { AppComponent } from "./app/app.component";
import { routes } from "./app/app.routes";
import { authInterceptor } from "./app/interceptors/auth.interceptor";
import { errorInterceptor } from "./app/interceptors/error.interceptor";
import { AuthService } from "./app/services/auth.service";
import { firstValueFrom } from "rxjs";

/**
 * Initialize auth state before app starts.
 * Checks for valid session from cookies before routing.
 */
function initializeAuth(): () => Promise<void> {
  return async () => {
    const authService = inject(AuthService);
    await firstValueFrom(authService.checkSession());
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      multi: true,
    },
  ],
}).catch((err) => console.error(err));
